import './CreateUsername.scss'

import * as React from 'react'
import Alert from 'react-s-alert'

import { Dispatch, bindActionCreators } from 'redux'
import {
  getUsernameError,
  usernameValidation,
} from '../../../common/forms-helper'
import { AppState } from '../../../redux/app-state'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

import {
  OnboardingActions,
  OnboardingCheckUsernameAction,
} from '../../../redux/onboarding/onboarding.actions'

import { useForm } from 'react-hook-form'

interface CreateUsernameProps {
  username: string
  hash: string
  errorMessage?: string
  isLoading?: boolean
  nextStep: (path: string) => void
  checkUsername: typeof OnboardingCheckUsernameAction
}

export function CreateUsernameForm(props: CreateUsernameProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const onSubmitEvent = (data: any) => {
    if (!data.username) {
      return
    }

    Alert.closeAll()

    props.checkUsername({
      username: data.username,
      hash: props.hash,
    })
  }

  // redirect or display alert if there is an error message
  if (props.username && !props.errorMessage && !props.isLoading) {
    props.nextStep('/onboard/create-password?q=' + props.hash)
  } else if (props.errorMessage && !props.isLoading) {
    Alert.error(props.errorMessage)
  }

  let usernameErrorMessage = getUsernameError(errors)

  return (
    <form
      onSubmit={handleSubmit(onSubmitEvent)}
      className="form onboarding-create-user"
    >
      <Typography component="p" variant="body1">
        Step 2 of 3
      </Typography>
      <Typography variant="h6">
        Please create a username. We recommend you use your email address so
        it's easy to remember!
      </Typography>

      <div className="fieldGroup login-field-group">
        <Typography component="p" variant="body1">
          Username
        </Typography>
        <TextField
          name="username"
          id="username"
          variant="outlined"
          margin="normal"
          disabled={props.isLoading}
          {...{
            ...register('username', usernameValidation),
            ref: undefined,
            inputRef: register('username', usernameValidation).ref,
          }}
          helperText={usernameErrorMessage}
          error={usernameErrorMessage ? true : false}
        />
      </div>
      <div className="action-group">
        <Button
          disableRipple
          disabled={props.isLoading}
          type="submit"
          variant="contained"
          color="primary"
        >
          {props.isLoading ? 'Submitting...' : 'Next'}
        </Button>
      </div>
    </form>
  )
}

export default connect(
  (state: AppState) => {
    return {
      username: state.onboarding.username,
      hash: state.routing.locationBeforeTransitions.query.q,
      errorMessage: state.onboarding.errorMessage,
      isLoading: state.onboarding.isLoading,
    }
  },
  (dispatch: Dispatch<OnboardingActions>) => ({
    checkUsername: bindActionCreators(OnboardingCheckUsernameAction, dispatch),
    nextStep: (path: string) => dispatch(routerActions.push(path)),
  }),
  null
)(CreateUsernameForm)
